import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { RootState } from 'src/configs/store';
import Icon from 'src/components/Icon/Icon';
import './BetslipTax.scss';

interface BetslipTaxProps {
  handleClick: () => void
}

function BetslipTax({ handleClick }: BetslipTaxProps) {
  const { t } = useTranslation();
  const { tax, potentialNetReturn, divisor } = useSelector((state: RootState) => state.betslip);

  return (
    <div className="betslip-tax">
      { t('betslip.tax') }:{ tax.taxPercentage }%
      <div className="tax-tooltip" onClick={ handleClick }>
        <Icon
          icon="Tooltip"
          className={
            classNames({
              'tax-tooltip__icon': true
            })
          }
        />
      </div>
      { potentialNetReturn > 0 && `| ${ t('betslip.potencialNetReturn') } : ${ (potentialNetReturn / divisor).toFixed(2) }` }
    </div>
  );
}

export default BetslipTax;
